import http from './http';

const encodePageName = (pageName: any) => encodeURIComponent(String(pageName ?? ''));

const pageStatusService = {
  async getPageStatus(student_id: any) {
    const res = await http.get(`api/page-status/student/${student_id}`);
    return res;
  },

  async getPageStatusByPageName(student_id: any, page_name: any): Promise<any> {
    const res = await http.get(`api/page-status/student/${student_id}/page/${encodePageName(page_name)}`);
    return res;
  },

  async markStudentCompleted(student_id: any, page_name: any, studentCompleted: boolean): Promise<any> {
    return http.post(
      `api/page-status/student/${student_id}/page/${encodePageName(page_name)}/complete`,
      { studentCompleted }
    );
  },

  async markCounselorVerified(
    student_id: any,
    page_name: any,
    counselorId: any,
    counselorVerified: boolean
  ): Promise<any> {
    return http.post(
      `api/page-status/student/${student_id}/page/${encodePageName(page_name)}/verify`,
      { counselor_id: counselorId, counselorVerified }
    );
  },
};

export default pageStatusService;